// Reasons for car application
export enum CarUninsuredReason {
  CancelledByInsurer = 'cancelledByInsurer',
  VehiculeStored = 'vehiculeStored',
  FinancialIncapacity = 'financialIncapacity',
  NewPurchaseOrTransfer = 'newPurchaseOrTransfer',
}

// Reasons for home / condo application
export enum HomeUninsuredReason {
  CancelledByInsurer = 'cancelledByInsurer',
  FinancialIncapacity = 'financialIncapacity',
  NoMortgage = 'noMortgage',
}
